import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatInputModule, MatButtonModule, MatRadioModule } from '@angular/material';

import { ButtonreasonComponent } from './buttonreason.component';

@NgModule({
    imports: [
        BrowserModule, FormsModule, ReactiveFormsModule, BrowserAnimationsModule, BrowserModule, FormsModule,
        MatInputModule, MatButtonModule, MatRadioModule
    ],
    entryComponents: [],
    exports: [
        ButtonreasonComponent
    ],
    declarations: [
        ButtonreasonComponent
    ],
    providers: [],
    bootstrap: []
})
export class ButtonreasonModule {
}